export default {
    setArchives : (archives) => {
        return {
            type: "SET_ARCHIVES",
            archives: archives
        }
    },
    setOutlines: (outlines) => {
        return  {
            type: "SET_OUTLINES",
            outlines: outlines
        }
    },
    requestSearch: (searchValues) => {
        console.log("Requesting primary search: ",searchValues);
        return {
            type: 'REQUEST_SEARCH',
            searchValues: searchValues
        }
    },
    receivedSearchResults: (results) => {
        return {
            type: 'RECEIVED_SEARCH_RESULTS',
            results: results
        }
    },
    receivedSearchError: (error) => {
        // debugger;
        return {
            type: 'RECEIVED_SEARCH_ERROR',
            primarySearchError: error
        }
    },
    clearPrimarySearch: () =>{
        return {
            type: "CLEAR_SEARCH"
        }
    }
}


// WEBPACK FOOTER //
// ./src/actionCreators/index.js